module.exports = __webpack_public_path__ + "static/media/location_page.a9444e17.svg";